<template>
   <div class="cp-worktab tabs">
     <el-tabs v-model="activeTab" type="card" @tab-remove="removeTab" @tab-click="clickTab" key="home">
       <el-tab-pane
         v-for="t in worktabs"
         :key="t.name"
         :label="t.tabname"
         :name="t.name"
         :closable="t.name !== 'Main'"
       >
       </el-tab-pane>
     </el-tabs>
   </div>
 </template>
 <script>
 export default {
   created () {
     // 进来不是主页时等list加载后再更新一次current
     let list=localStorage.getItem("worktabList");
     //console.log('list',list,this.$store.state.worktab.list)
     if(list&&list!=''){
       this.$store.state.worktab.list=[];

       let wlist=JSON.parse(list);

       wlist.forEach(item=>{
         if(item&&item.name!=''){
           //console.log('item:',item)
           this.$store.state.worktab.list.push(item);
         }
       })
     }

     setTimeout(() => {
       this.activeTab = this.$store.state.worktab.current.name
     }, 500)
   },
   watch: {
     '$store.state.worktab.current' (tab) {
       this.activeTab = tab.name
     }
   },
   computed: {
     worktabs () {
       return this.$store.state.worktab.list
     }
   },
   data () {
     return {
       activeTab: 'name'
     }
   },
   methods: {
     clickTab (tab) {
       //console.log('tabclick:',tab);
       //console.log('worktabs:',this.worktabs);
       this.$router.push(this.worktabs[1 * tab.index].path);
       //this.$router.replace(this.worktabs[1 * tab.index].path);
     },
     removeTab (name) {
       //console.log('removeTab:',name);
       this.$store.dispatch('worktabRemove', name)
     }
   }
 }
 </script>
<style>
  .tabs .el-tabs__item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    background-color: #c1c8cc;
    background-color: #d1d8dc;
    background-color: #FFFFFF;
    /* border: 1px solid #a4adb3; */
    /* border-radius: 5px 5px 0px 0px; */
    font-size: 14px;
    color: #595467;
    /* box-shadow:inset 0px 15px 2px -15px #93b0b0,inset -15px 0px  2px -15px #93b0b0; */
  }
  .tabs .el-tabs__item:hover {
    background-color: #d8f6ef;

  }
  .tabs .el-tabs__item.is-active {
    background-color: #e1e9ee;
    background-color: #3fc8dd;
    height: 40px;
    color: #00007f;
    color: #FFFFFF;
  }
  .tabs .el-tabs--card>.el-tabs__header .el-tabs__item {
    border-left: 1px solid #c1c8cc;
    border-left: 0px solid #c1c8cc;
  }
  .tabs .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-left: 0px solid #FFFFFF;
    border-bottom: 0px solid #c1c8cc;
  }
  .tabs .el-tabs__nav-next {
    line-height: 32px;
  }
  .tabs .el-tabs__nav-prev {
    line-height: 32px;
  }
  .tabs .el-tabs__item.is-active .el-icon-close:before {
    color: #595467;
    font-weight: 900;
    color: #FFFFFF;
  }
</style>
